export enum TipoUsuario {
    MONTADORA = "MONTADORA",
    TECSINAPSE = "TECSINAPSE",
    DEALER_GRUPO = "DEALER_GRUPO"
}
